export enum ActionTypeEnum {
  Exchange,
  Deposit,
  Withdraw,
}
